import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import useTranslation from "next-translate/useTranslation";
import { Box, Input, FormControl, FormLabel, FormErrorMessage } from "@chakra-ui/react";
import { useAuthDispatch, useAuthState } from "src/shared/contexts/AuthContext";
import { Button } from "src/shared/components/Button";
import SmileSharedProfileLayout from "../../../../shared/components/Layouts/SmileSharedProfileLayout";

interface SmileProfileChangeNameScreenProps {
  onClose: () => void;
}

interface FormFieldValues {
  firstName: string;
  lastName: string;
}

const SmileProfileChangeNameScreen = (props: SmileProfileChangeNameScreenProps) => {
  const { t } = useTranslation();
  const { profile } = useAuthState();
  const { updateUserInfos } = useAuthDispatch();
  const formMethods = useForm<FormFieldValues>({
    mode: "onBlur",
    defaultValues: {
      firstName: profile?.infos?.firstName ?? "",
      lastName: profile?.infos?.lastName ?? "",
    },
  });
  const { errors, register } = formMethods;

  const handleSubmit = formMethods.handleSubmit(async (values) => {
    await updateUserInfos({
      firstName: values.firstName,
      lastName: values.lastName,
    });
    props.onClose();
  });

  return (
    <SmileSharedProfileLayout title={"Change name"} onGotoBack={props.onClose}>
      <Box maxW={{ base: "unset", sm: "400px" }}>
        <FormProvider {...formMethods}>
          <form onSubmit={handleSubmit}>
            <FormControl id="firstName" isInvalid={!!errors.firstName} isRequired>
              <FormLabel fontWeight="bold" fontSize="16px" lineHeight="20px" mt="50px">
                {t("smile:pixSignup_firstNameLabel")}
              </FormLabel>
              <Input
                variant="flushed"
                w="100%"
                name="firstName"
                ref={register({ required: t("smile:form_formRequiredField") })}
              />
              <FormErrorMessage>{errors.firstName?.message}</FormErrorMessage>
            </FormControl>
            <FormControl id="lastName" isInvalid={!!errors.firstName} isRequired>
              <FormLabel fontWeight="bold" fontSize="16px" lineHeight="20px" mt="50px">
                {t("smile:pixSignup_lastNameLabel")}
              </FormLabel>
              <Input
                variant="flushed"
                w="100%"
                name="lastName"
                ref={register({ required: t("smile:form_formRequiredField") })}
              />
              <FormErrorMessage>{errors.lastName?.message}</FormErrorMessage>
            </FormControl>
            <Box mt={"88px"} display={"flex"} justifyContent={{ base: "center", sm: "unset" }}>
              <Button type="submit" isLoading={formMethods.formState.isSubmitting}>
                Update
              </Button>
            </Box>
          </form>
        </FormProvider>
      </Box>
    </SmileSharedProfileLayout>
  );
};

export default SmileProfileChangeNameScreen;
